
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { useEffect } from 'react';
import { RolrLanding } from '@features/onboarding/containers';
import { RolrSetupLayout } from '@features/onboarding/layout';
import { rolrAuthRepSection } from '@services/sections/lib/signup';
import { AppPage } from '@shared/layout/core';
import { useRouter } from 'next/router';
const RolrLandingPage: React.FC = () => {
    const router = useRouter();
    useEffect(() => {
        void router.prefetch(rolrAuthRepSection.route);
    }, [router]);
    return <RolrLanding />;
};
const __Next_Translate__Page__19620bc1826__ = AppPage(RolrLandingPage, {
    getLayout: (page) => (<RolrSetupLayout currentStep="landing">{page}</RolrSetupLayout>)
});

    export default __appWithI18n(__Next_Translate__Page__19620bc1826__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  